(function ($) {
    $(document).ready(function(){

        $(".gallery").each(function () {

            var this_gallery = $(this),
                // blockList = block.find(".gallery__list"),
                // blockItem = block.find(".gallery__item"),
                blockArrows = this_gallery[0].querySelector(".arrows");
                blockDots = this_gallery[0].querySelector(".gallery__dots");

            console.log(blockArrows);

            var GALLERY = "";

            function paramsSlider(slidesPerView, slidesPerGroup) {
                var options = {
                    init: true,
                    wrapperClass: "gallery__list-inner",
                    slideClass: "gallery__item",
                    slidesPerView: slidesPerView,
                    slidesPerGroup: slidesPerGroup,
                    setWrapperSize: true,
                    grabCursor: true,
                    // watchOverflow: true,
                    // updateOnWindowResize: true,
                    // observer: true,
                    // observeSlideChildren: true,
                    spaceBetween: 16,
                    // loop: true,
                    // loopFillGroupWithBlank: true,
                    // freeMode: true,
                    // freeModeMomentum: true,
                    navigation: {
                        nextEl: this_gallery[0].querySelector(".gallery .arrows__next"),
                        prevEl: this_gallery[0].querySelector(".gallery .arrows__prev"),
                        disabledClass: "arrows__arrow_disabled",
                    },
                    pagination: {
                        el: this_gallery[0].querySelector(".gallery__dots .dots"),
                        bulletClass: "dots__dot",
                        bulletActiveClass: "active",
                        dynamicBullets: true,
                        clickable: true,
                    },
                };
                GALLERY = new Swiper(this_gallery[0].querySelector(".gallery__list"), options);
                // GALLERY.init();
            }

            var windowWidth = $("body").width();

            // if (windowWidth >= 992) {
            //     blockDots.style.display = "none";
            // }

            if (windowWidth >= 992) {
                if ($(".gallery .gallery__item").not(".swiper-slide-duplicate").length >= 4) {
                    paramsSlider(
                        slidesPerView = 4,
                        slidesPerGroup = 4,
                    );
                    blockArrows.style.opacity = "1";
                    blockArrows.style.visibility = "visible";
                    blockDots.style.display = "flex";
                }
            }

            if (windowWidth >= 640 && windowWidth <= 991) {
                if ($(".gallery .gallery__item").not(".swiper-slide-duplicate").length >= 3) {
                    paramsSlider(
                        slidesPerView = 3,
                        slidesPerGroup = 3,
                    );
                    blockDots.style.display = "flex";
                }
            }

            if (windowWidth <= 639) {
                if ($(".gallery .gallery__item").not(".swiper-slide-duplicate").length > 2) {
                    paramsSlider(
                        slidesPerView = 1,
                        slidesPerGroup = 1,
                    );
                    blockDots.style.display = "flex";
                }
            }

            lightGallery(".gallery", "a");

        });

    });
})(jQuery);
